export default "https://cdn-static.gokick.com/assets/b96dd49a95534624185e45ca053b90dd739d9b4e/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";